export const prefersColorSchemeDarkQuery = window.matchMedia('(prefers-color-scheme: dark)');
